module.exports = __webpack_public_path__ + "519e3de544b46b3524a5a2bbbc383625.svg";